import { createFileRoute } from '@tanstack/react-router';
import { SurveyRespondPage } from '@/features/people/public/survey-respond-page';

export const Route = createFileRoute('/_public/s/$token')({ component: SurveyRoute });

function SurveyRoute() {
  const { token } = Route.useParams();
  return <SurveyRespondPage token={token} />;
}
